<script>
export default {
  data() {
    return {
      list: [
        {
          title: '消費方案一次滿足',
          content: '包月包套模組與儲值金，滿足你對寵物服務的預收款所有需求！'
        },
        {
          title: '單店設定',
          content: '初階方案提供單間門市的設置。若有特殊活動，可暫時關閉網站的預約；不過請放心，您仍可從後台自由控管與新增預約。'
        },
        {
          title: '自動簡訊通知',
          content: '每月提供100封簡訊，由系統自動發送預約確認和提醒，同時也可針對溝通需求，編寫簡訊寄送給客戶。如使用完畢可加購簡訊點數。'
        },
      ]
    }
  }
}
</script>

<template>
  <div :class="$style.sectionSecondary">
    <div class="sectionSecondary__bg d-xl-block d-none">
      
    </div>
    <!-- <img src="@assets/images/home/section7-image.png" alt="" class="sectionSecondary__img"> -->
    <div class="section container">
      <div class="row sectionSecondary__list flex-xl-row-reverse">
        <div class="col-xl-5 col-12 sectionSecondary__item--left text-xl-left text-center">
          <BaseSectionTitle 
            title="<p>節省時間，<br>輕鬆與您的客戶保持聯繫</p>" 
            sub-title="Be Ahead" 
            class="isStyleDecoration mx-xl-0 isxlCenter mx-auto"
          />
          <ul class="list-unstyled isStyleBase">
            <li 
              v-for="(item,$index) in list"
              :key="$index"
            >
              <h3 class="title">{{item.title}}</h3>
              <div class="content" v-html="item.content"></div>
            </li>
          </ul>
           
        </div>
        <div class="col-xl-7 col-12 sectionSecondary__item--right">
          <div class="img d-xl-none d-flex">
            <img src="@assets/images/basicplan/section6-image.svg" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" module>
.sectionSecondary {
  position: relative;
  &:before {
    
    content: '';
    position: absolute;
    // bottom: 5%;
    top: 0;
    left: 0;
    background-image: url('@assets/images/basicplan/section6-bg.svg');
    background-repeat: no-repeat;
    background-size: cover;
    width: 40%;
    padding-bottom: 60%;
    @include max-xl {
      display: none;
    }
  }
  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    right: 0;
    background-image: url('@assets/images/basicplan/section6-bg2.svg');
    background-repeat: no-repeat;
    background-size: cover;
    width: 219px;
    padding-bottom: 16.25%;
    @include max-xl {
      display: none;
    }
  }
  :global {
    .sectionSecondary{
      // &__img {
      //   position: absolute;
      //   right: 0;
      // }
      &__bg {
        position: absolute;
        top: 28%;
        left: 20%;
        background-image: url('~@assets/images/basicplan/section6-image.svg');
        background-repeat: no-repeat;
        background-size: cover;
        width: 30%;
        padding-bottom: 29%;
        
      }
      &__item {
        &--right {
        img {
          //  width: 600px;
        }
        .img {
          background-image: url('~@assets/images/basicplan/section6-bg.svg');
          background-repeat: no-repeat;
          background-size: contain;
          width: 100%;
          padding-bottom: 28%;
          position: relative;
          left: -20px;
          // display: flex;
          justify-content: center;
          img {
            position: relative;
            top: 50px;
            padding-left: 20;
            padding-right: 20px;
          }
        }
          // margin-left: 3;
        }
        &--left {
          // position: relative;
          // left: calc((-100vw + 1200px)/2);
        }
      }
      &__collapse {
        // margin-top: 105px;
      }
    }
  }
}
</style>